import { useEffect, useRef } from 'react';

const useResizeObserver = (callback: any) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new ResizeObserver((entries) => {
      if (callback) {
        entries.forEach(entry => callback(entry.contentRect));
      }
    });

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [callback]);

  return ref;
};

export default useResizeObserver;